import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getObersterVertriebspartnerColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: "Vertriebspartner",
    accessorKey: "obersterVertriebspartner",
    filterFn: "includesString"
  };
}

export { getObersterVertriebspartnerColumn };
